import axios from 'axios'
import store from '../store'
import { Notification, Message } from 'element-ui'
import { getBaseUrl } from '@/umcc/util'
import { $t } from '../i18n'
import db from '../db'

Object.assign(axios.defaults, {
  baseURL: getBaseUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  }
})

const codeMsg = {
  default: '未知网络错误，请稍后重试',
  500: '服务端出错，请稍后重试',
  504: '连接超时，请稍后重试'
}

axios.interceptors.response.use(
  res => {
    const rawRes = res.data

    if (rawRes.code === 1) {
      return rawRes.data
    } else {
      Message.error({
        message: $t(rawRes.msg),
        duration: 20000,
        showClose: true,
        center: true
      })
      return Promise.reject(new Error(rawRes.msg))
    }
  },
  err => {
    const code = err.response.status

    if (code === 401) {
      store.commit('common/setUser', null)
      db.from_url = window.location.href
      window.location.href = '/login'
      return
    }
    Notification.error($t(codeMsg[code] || codeMsg.default))
  }
)
